import * as React from "react";
import { SliderProps } from "@mui/material/Slider";
import { PrettoSlider, ValueLabel } from "./style";

interface PrettoSliderProps extends SliderProps {
  onChange?: (event: Event, newValue: number | number[]) => void;
}

const PrettoSliderComponent: React.FC<PrettoSliderProps> = (props) => {
  const [value, setValue] = React.useState<number>(props.value as number);

  const handleChange = (event: Event, newValue: number | number[]) => {
    if (typeof newValue === "number") {
      setValue(newValue);
    }
    props.onChange?.(event, newValue);
  };

  const leftPosition = `${(value / (props.max || 100)) * 100}%`;

  return (
    <div style={{ position: "relative" }}>
      <PrettoSlider
        {...props}
        value={value}
        onChange={handleChange}
        valueLabelDisplay="auto"
      />
      <ValueLabel left={leftPosition}>{value}</ValueLabel>
    </div>
  );
};

export default PrettoSliderComponent;
